import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { ButtonInterface } from "../../realms/types/button.interface"

export class Button extends Component<ButtonInterface> {
    setBackgroundColor(backgroundColor?: string) {
        if (backgroundColor) {
            this.element?.style.setProperty(
                "--button-background-color",
                backgroundColor
            )
        }
    }

    setHoverBackgroundColor(hoverColor?: string) {
        if (hoverColor) {
            this.element?.style.setProperty(
                "--button-hover-background-color",
                hoverColor
            )
            this.element?.style.setProperty(
                "--button-active-background-color",
                hoverColor
            )
        }
    }

    override setWidth(width?: string) {
        if (width) {
            this.element?.style.setProperty("--button-width", width)
        }
    }

    private setMinWidth(minWidth?: string) {
        if (minWidth) {
            this.element?.style.setProperty("--button-min-width", minWidth)
        }
    }

    @handleComponentError("Button")
    render() {
        this.setBackgroundColor(this.props.backgroundColor)
        this.setHoverBackgroundColor(this.props.hoverColor)
        this.setWidth(this.props.width)
        this.setMinWidth(this.props.minWidth)
        this.show(this.props.isVisible)

        super.render()
    }
}
